import {Action, Catalog, FormattedDate} from '../../../../common/types/common';
import { PipefySummaryDTO } from '../types/epics';

export const SET_PIPEFY_DATA_STATE_ACTION: Action = {
    name: 'SET_PIPEFY_DATA_STATE_ACTION',
    action: (pipefyData: PipefySummaryDTO) => ({
        pipefyData,
        type: SET_PIPEFY_DATA_STATE_ACTION.name
    })
};

export const UPDATE_PIPEFY_DATA_STATE_REQUEST_ACTION: Action = {
    name: 'UPDATE_PIPEFY_DATA_STATE_REQUEST_ACTION',
    action: () => ({
        type: UPDATE_PIPEFY_DATA_STATE_REQUEST_ACTION.name
    })
};

export const UPDATE_PIPEFY_DATA_STATE_SUCCESSFUL_ACTION: Action = {
    name: 'UPDATE_PIPEFY_DATA_STATE_SUCCESSFUL_ACTION',
    action: (syncBy: string = '', lastSyncDate: FormattedDate) => ({
        syncBy,
        lastSyncDate,
        type: UPDATE_PIPEFY_DATA_STATE_SUCCESSFUL_ACTION.name
    })
};

export const UPDATE_PIPEFY_DATA_STATE_ERROR_ACTION: Action = {
    name: 'UPDATE_PIPEFY_DATA_STATE_ERROR_ACTION',
    action: (error: string) => ({
        error,
        type: UPDATE_PIPEFY_DATA_STATE_ERROR_ACTION.name
    })
};

export const SET_PIPEFY_CREDITAS_DATA_STATE_ACTION: Action = {
    name: 'SET_PIPEFY_CREDITAS_DATA_STATE_ACTION',
    action: (pipefyData: PipefySummaryDTO) => ({
        pipefyData,
        type: SET_PIPEFY_CREDITAS_DATA_STATE_ACTION.name
    })
};

export const SET_PIPEFY_RAPIDAUTO_DATA_STATE_ACTION: Action = {
    name: 'SET_PIPEFY_RAPIDAUTO_DATA_STATE_ACTION',
    action: (pipefyData: PipefySummaryDTO) => ({
        pipefyData,
        type: SET_PIPEFY_RAPIDAUTO_DATA_STATE_ACTION.name
    })
};

export const SEND_TO_PIPEFY_REQUEST_ACTION: Action = {
    name: 'SEND_TO_PIPEFY_REQUEST_ACTION',
    action: (bank: Catalog) => ({
        bank,
        type: SEND_TO_PIPEFY_REQUEST_ACTION.name
    })
};